/**
 * Warenkorb-Sidebar (sections/cart-drawer.liquid).
 * Gift lines sync after drawer quantity changes. A removed gift stays
 * out (cart attribute _mk_skip_rewards) until the cart drops below it.
 * Opens after add-to-cart and on the header cart icon. Line changes go through
 * jQuery so maikind-cart-prio.js still sweeps Prio+ when the last product leaves.
 */
(function () {
  'use strict';

  if (window.__mkCartDrawerInit) return;
  window.__mkCartDrawerInit = true;

  var SECTION_ID = 'cart-drawer';
  var EXIT_MS = 200;

  var closeTimer = 0;
  var returnFocusTo = null;
  var pending = null;
  var queue = {};
  var stale = false;
  var addingFavorite = false;
  var pendingCelebrate = null;

  function noop() {}

  function getDialog() {
    var dialog = document.getElementById('CartDrawer');
    if (dialog && !dialog._mkBound) bind(dialog);
    return dialog;
  }

  function sectionUrl() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + '?sections=' + SECTION_ID;
  }

  function lockScroll() {
    document.documentElement.classList.add('mk-scroll-lock');
  }

  function unlockScroll() {
    document.documentElement.classList.remove('mk-scroll-lock');
  }

  function clearViewport() {
    var dialog = document.getElementById('CartDrawer');
    if (!dialog) return;
    dialog.style.top = '';
    dialog.style.height = '';
  }

  function syncViewport() {
    var dialog = document.getElementById('CartDrawer');
    if (!dialog || !dialog.open || !window.visualViewport) {
      clearViewport();
      return;
    }
    var vv = window.visualViewport;
    var offset = Math.max(0, Math.round(vv.offsetTop));
    var height = Math.round(vv.height);
    var covered = window.innerHeight - height - offset;
    if (covered < 150 && offset < 1) {
      clearViewport();
      return;
    }
    dialog.style.top = offset + 'px';
    dialog.style.height = height + 'px';
  }

  function visibleHeaderCartLink() {
    var links = document.querySelectorAll('.header-cart > a, .header-cart > button');
    for (var i = 0; i < links.length; i++) {
      if (links[i].offsetParent !== null) return links[i];
    }
    return links[0] || null;
  }

  function cartTriggerFrom(target) {
    if (!target || !target.closest) return null;
    return target.closest('.header-cart > a, .header-cart > button');
  }

  function onCartPage() {
    return document.body.classList.contains('template-cart');
  }

  function open(trigger) {
    if (onCartPage()) return false;
    var dialog = getDialog();
    if (!dialog) return false;
    window.clearTimeout(closeTimer);
    if (!dialog.open) {
      returnFocusTo = trigger || document.activeElement;
      lockScroll();
      dialog.showModal();
    }
    void dialog.offsetWidth;
    dialog.classList.add('is-open');
    if (pendingCelebrate) {
      var queued = pendingCelebrate;
      pendingCelebrate = null;
      window.requestAnimationFrame(function () {
        applyCelebrate(dialog, queued);
      });
    }
    syncViewport();
    window.requestAnimationFrame(function () {
      syncFavorites(dialog);
    });
    return true;
  }

  function close() {
    var dialog = getDialog();
    if (!dialog || !dialog.open) return;
    clearViewport();
    dialog.classList.remove('is-open');
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(function () {
      dialog.close();
    }, EXIT_MS);
  }

  function onClosed() {
    var dialog = getDialog();
    if (dialog) dialog.classList.remove('is-open');
    unlockScroll();
    var target = returnFocusTo && returnFocusTo.isConnected ? returnFocusTo : visibleHeaderCartLink();
    returnFocusTo = null;
    if (target && typeof target.focus === 'function') target.focus({ preventScroll: true });
  }

  function lineEl(root, key) {
    return root.querySelector('[data-line-key="' + CSS.escape(key) + '"]');
  }

  function snapshot(root) {
    var note = root.querySelector('[data-focus="note"]');
    var details = root.querySelector('[data-cart-note]');
    var active = document.activeElement;
    var state = {
      note: note ? note.value : null,
      noteOpen: details ? details.open : null,
      focus: null,
      line: null,
      selection: null
    };
    if (active && root.contains(active) && active.hasAttribute('data-focus')) {
      var line = active.closest('[data-line-key]');
      state.focus = active.getAttribute('data-focus');
      state.line = line ? line.getAttribute('data-line-key') : null;
      if (active === note) state.selection = [note.selectionStart, note.selectionEnd];
    }
    return state;
  }

  function restore(root, state) {
    var note = root.querySelector('[data-focus="note"]');
    var details = root.querySelector('[data-cart-note]');
    if (note && state.note !== null) note.value = state.note;
    if (details && state.noteOpen !== null) details.open = state.noteOpen;

    Object.keys(queue).forEach(function (key) {
      var line = lineEl(root, key);
      var input = line && line.querySelector('[data-focus="qty"]');
      if (input) input.value = queue[key];
    });

    if (!state.focus) return;
    var scope = state.line ? lineEl(root, state.line) : root;
    var target = scope && scope.querySelector('[data-focus="' + state.focus + '"]');
    if (target && target.disabled) target = scope.querySelector('[data-focus="qty"]');
    if (!target) target = root.querySelector('[data-cart-drawer-title]');
    if (!target) return;
    target.focus({ preventScroll: true });
    if (state.selection && target === note) note.setSelectionRange(state.selection[0], state.selection[1]);
  }

  function rewardDoneSet(root) {
    var done = {};
    var steps = root.querySelectorAll('[data-mk-reward-step]');
    for (var i = 0; i < steps.length; i++) {
      if (steps[i].classList.contains('is-done')) done[i] = true;
    }
    return done;
  }

  function applyCelebrate(root, indexes) {
    var steps = root.querySelectorAll('[data-mk-reward-step]');
    var wave = 0;
    for (var i = 0; i < indexes.length; i++) {
      var step = steps[indexes[i]];
      if (!step || !step.classList.contains('is-done')) continue;
      step.style.setProperty('--mk-pop-delay', (wave * 70) + 'ms');
      step.classList.add('is-celebrate');
      wave += 1;
    }
  }

  function rewardScale(fill) {
    if (!fill) return null;
    var transform = window.getComputedStyle(fill).transform;
    if (!transform || transform === 'none') return null;
    var scale = parseFloat(transform.slice(7));
    return isFinite(scale) ? scale : null;
  }

  function growReward(fill, fromScale) {
    if (!fill || fromScale === null) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var meter = fill.closest('.mk-cart-rewards__meter');
    var progress = meter ? parseFloat(meter.style.getPropertyValue('--mk-rewards-progress')) : NaN;
    if (!isFinite(progress)) return;
    var toScale = progress / 10000;
    if (Math.abs(toScale - fromScale) < 0.0005) return;
    fill.style.transition = 'none';
    fill.style.transform = 'scaleX(' + fromScale + ')';
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        if (!fill.isConnected) return;
        fill.style.transition = '';
        fill.classList.add('is-grow');
        fill.style.transform = 'scaleX(' + toScale + ')';
      });
    });
  }

  function celebrateNewRewards(root, before) {
    var fresh = [];
    var steps = root.querySelectorAll('[data-mk-reward-step]');
    for (var i = 0; i < steps.length; i++) {
      if (steps[i].classList.contains('is-done') && !before[i]) fresh.push(i);
    }
    if (!fresh.length) {
      pendingCelebrate = null;
      return;
    }
    var dialog = getDialog();
    if (dialog && (dialog.open || dialog.classList.contains('is-open'))) {
      pendingCelebrate = null;
      applyCelebrate(root, fresh);
      return;
    }
    pendingCelebrate = fresh;
  }

  function render(html) {
    var dialog = getDialog();
    if (!dialog || !html) return;
    var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer-content]');
    var current = dialog.querySelector('[data-cart-drawer-content]');
    if (!next || !current) return;
    var state = snapshot(current);
    var before = rewardDoneSet(current);
    var fromScale = rewardScale(current.querySelector('.mk-cart-rewards__fill'));
    current.innerHTML = next.innerHTML;
    growReward(current.querySelector('.mk-cart-rewards__fill'), fromScale);
    celebrateNewRewards(current, before);
    restore(current, state);
    stale = false;
    bindFavorites(dialog);
  }

  function refresh() {
    return fetch(sectionUrl(), { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('cart-drawer ' + r.status);
        return r.json();
      })
      .then(function (data) {
        render(data[SECTION_ID]);
      });
  }

  function syncHeaderCount(cart) {
    if (!cart || !cart.items || !window.theme || typeof theme.cartVisibleQuantity !== 'function') return;
    var count = String(theme.cartVisibleQuantity(cart));
    document.querySelectorAll('.header-cart__count').forEach(function (el) {
      el.textContent = count;
    });
  }

  function showError(message) {
    var dialog = getDialog();
    var el = dialog && dialog.querySelector('[data-cart-drawer-error]');
    if (!el) return;
    var text = message === '' ? '' : message || dialog.getAttribute('data-error-text') || '';
    window.requestAnimationFrame(function () {
      el.textContent = text;
    });
  }

  function changeLine(key, quantity) {
    var dialog = getDialog();
    var line = dialog && lineEl(dialog, key);
    var rewardId = quantity === 0 && line ? line.getAttribute('data-reward-id') || '' : '';
    if (rewardId) removingReward[rewardId] = true;
    if (line) line.setAttribute('aria-busy', 'true');
    showError('');

    var ready = rewardId ? declineReward(rewardId) : Promise.resolve();
    return ready.then(function () {
      return new Promise(function (resolve) {
        jQuery.ajax({
          type: 'POST',
          url: theme.routes.cart_change_url + '.js',
          data: JSON.stringify({
            id: key,
            quantity: quantity,
            sections: SECTION_ID,
            sections_url: window.location.pathname
          }),
          contentType: 'application/json',
          dataType: 'json'
        }).done(function (cart) {
          syncHeaderCount(cart);
          syncRewards().then(function (synced) {
            if (synced) return syncCountFromCart();
            return refresh().then(syncCountFromCart);
          }).catch(noop).then(resolve);
        }).fail(function (xhr) {
          var json = xhr.responseJSON || {};
          var message = typeof json.description === 'string' ? json.description : json.message;
          refresh().catch(noop).then(function () {
            showError(typeof message === 'string' ? message : null);
            resolve();
          });
        });
      });
    }).then(function () {
      if (rewardId) delete removingReward[rewardId];
      var busyLine = dialog && lineEl(dialog, key);
      if (busyLine) busyLine.removeAttribute('aria-busy');
    });
  }

  function schedule(key, quantity) {
    if (pending) {
      queue[key] = quantity;
      return;
    }
    pending = changeLine(key, quantity).then(function () {
      pending = null;
      var nextKey = Object.keys(queue)[0];
      if (nextKey) {
        var nextQty = queue[nextKey];
        delete queue[nextKey];
        schedule(nextKey, nextQty);
      }
    });
  }

  function idle() {
    return pending ? pending.then(idle) : Promise.resolve();
  }

  function lineKeyOf(el) {
    var line = el.closest('[data-line-key]');
    return line ? line.getAttribute('data-line-key') : null;
  }

  function clamp(input, value) {
    var max = parseInt(input.getAttribute('max'), 10);
    if (!isNaN(max) && value > max) return max;
    return Math.max(0, value);
  }

  function commitInput(input) {
    var initial = parseInt(input.getAttribute('data-initial-value'), 10);
    var raw = input.value.trim();
    var value = parseInt(raw, 10);
    if (raw === '' || isNaN(value)) {
      input.value = initial;
      return;
    }
    value = clamp(input, value);
    input.value = value;
    if (value === initial && !(lineKeyOf(input) in queue)) return;
    schedule(lineKeyOf(input), value);
  }

  function submitCheckout() {
    var form = document.getElementById('CartDrawer-form');
    if (!form) return;
    var button = form.querySelector('[name="checkout"]');
    if (button && typeof form.requestSubmit === 'function') {
      form.requestSubmit(button);
      return;
    }
    var hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = 'checkout';
    form.appendChild(hidden);
    form.submit();
  }

  function favMetrics(track) {
    var card = track.querySelector('[data-fav-card]');
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    var width = card ? card.getBoundingClientRect().width : track.clientWidth;
    return {
      step: width + gap,
      max: Math.max(0, track.scrollWidth - track.clientWidth)
    };
  }

  function syncFavorites(dialog) {
    if (!dialog) return;
    var track = dialog.querySelector('[data-fav-track]');
    var prev = dialog.querySelector('[data-fav-prev]');
    var next = dialog.querySelector('[data-fav-next]');
    if (!track || (!prev && !next)) return;
    var max = track.scrollWidth - track.clientWidth;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = max <= 2 || track.scrollLeft >= max - 2;
  }

  function snapFavorites(track) {
    var metrics = favMetrics(track);
    if (!metrics.step) return;
    var index = Math.round(track.scrollLeft / metrics.step);
    var left = Math.min(metrics.max, Math.max(0, index * metrics.step));
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
  }

  function bindFavorites(dialog) {
    if (!dialog) return;
    var track = dialog.querySelector('[data-fav-track]');
    if (!track || track._mkFav) {
      syncFavorites(dialog);
      return;
    }
    track._mkFav = true;
    var drag = null;

    track.addEventListener('scroll', function () {
      syncFavorites(dialog);
    }, { passive: true });

    track.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (e.target.closest('select, input, button')) return;
      drag = {
        id: e.pointerId,
        x: e.clientX,
        left: track.scrollLeft,
        moved: false
      };
      track.setPointerCapture(e.pointerId);
    });

    track.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) < 4) return;
      drag.moved = true;
      track.classList.add('is-dragging');
      track.scrollLeft = drag.left - dx;
    });

    function endDrag(e) {
      if (!drag || e.pointerId !== drag.id) return;
      var moved = drag.moved;
      drag = null;
      if (track.hasPointerCapture(e.pointerId)) track.releasePointerCapture(e.pointerId);
      track.classList.remove('is-dragging');
      if (!moved) return;
      track._mkSuppressClick = true;
      snapFavorites(track);
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    track.addEventListener('click', function (e) {
      if (!track._mkSuppressClick) return;
      track._mkSuppressClick = false;
      e.preventDefault();
      e.stopPropagation();
    }, true);

    syncFavorites(dialog);
  }

  function scrollFavorites(direction) {
    var dialog = getDialog();
    var track = dialog && dialog.querySelector('[data-fav-track]');
    if (!track) return;
    var metrics = favMetrics(track);
    if (!metrics.step) return;
    var index = Math.round(track.scrollLeft / metrics.step) + direction;
    var left = Math.min(metrics.max, Math.max(0, index * metrics.step));
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
  }

  function syncFavoriteOption(select) {
    var card = select.closest('[data-fav-card]');
    if (!card) return;
    var option = select.options[select.selectedIndex];
    if (!option) return;
    var button = card.querySelector('[data-fav-add]');
    if (button) {
      button.setAttribute('data-variant-id', option.value);
      button.disabled = option.disabled;
    }
    var price = card.querySelector('[data-fav-price]');
    if (price) price.textContent = option.getAttribute('data-price') || '';
    var compare = card.querySelector('[data-fav-compare]');
    var compareValue = option.getAttribute('data-compare') || '';
    if (compare) {
      var money = compare.querySelector('[data-fav-compare-value]');
      if (compareValue) {
        compare.hidden = false;
        if (money) money.textContent = compareValue;
      } else {
        compare.hidden = true;
      }
    }
    var unit = card.querySelector('[data-fav-unit]');
    if (unit) unit.textContent = option.getAttribute('data-unit') || '';
  }

  function cartEndpoint(routeKey, fallback) {
    if (window.theme && theme.routes && theme.routes[routeKey]) return theme.routes[routeKey] + '.js';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + fallback;
  }

  function readJson(response) {
    return response.json().then(function (data) {
      if (!response.ok) {
        var error = new Error('cart');
        error.payload = data;
        throw error;
      }
      return data;
    });
  }

  function syncCountFromCart() {
    return fetch(cartEndpoint('cart_url', 'cart.js'), { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) { if (cart) syncHeaderCount(cart); })
      .catch(noop);
  }

  function focusAddedLine(item) {
    var dialog = getDialog();
    var line = item && item.key && dialog && lineEl(dialog, item.key);
    if (!line) return;
    var body = line.closest('.mk-cart-drawer__body');
    if (body) body.scrollTop = 0;
    var title = line.querySelector('[data-focus="title"]');
    if (title) title.focus({ preventScroll: true });
  }

  function releaseFavorite(productId) {
    addingFavorite = false;
    var dialog = getDialog();
    var card = dialog && productId && dialog.querySelector('[data-product-id="' + CSS.escape(String(productId)) + '"]');
    if (!card) return;
    card.removeAttribute('aria-busy');
    var button = card.querySelector('[data-fav-add]');
    var select = card.querySelector('[data-fav-select]');
    var option = select && select.options[select.selectedIndex];
    if (button) button.disabled = !!(option && option.disabled);
  }

  function addFavorite(button) {
    if (addingFavorite || button.disabled) return;
    var card = button.closest('[data-fav-card]');
    if (!card) return;
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;
    var productId = card.getAttribute('data-product-id');
    addingFavorite = true;
    card.setAttribute('aria-busy', 'true');
    button.disabled = true;
    showError('');

    idle().then(function () {
      return fetch(cartEndpoint('cart_add_url', 'cart/add.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: /^\d+$/.test(variantId) ? Number(variantId) : variantId,
          quantity: 1,
          sections: SECTION_ID,
          sections_url: window.location.pathname
        })
      }).then(readJson);
    }).then(function (item) {
      return syncRewards().then(function (synced) {
        if (synced) return item;
        return refresh().then(function () { return item; });
      });
    }).then(function (item) {
      return syncCountFromCart().then(function () { return item; });
    }).then(function (item) {
      addingFavorite = false;
      focusAddedLine(item);
    }).catch(function (err) {
      var payload = err && err.payload;
      var message = payload && (typeof payload.description === 'string' ? payload.description : payload.message);
      releaseFavorite(productId);
      showError(typeof message === 'string' ? message : null);
    });
  }

  function bind(dialog) {
    dialog._mkBound = true;

    dialog.addEventListener('cancel', function (e) {
      e.preventDefault();
      close();
    });

    dialog.addEventListener('close', onClosed);

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog || e.target.closest('[data-cart-drawer-close]')) {
        close();
        return;
      }

      var rewardStep = e.target.closest('[data-mk-reward-step]');
      if (rewardStep) {
        var pinned = rewardStep.classList.contains('is-tip');
        closeRewardTips(dialog);
        if (!pinned) {
          rewardStep.classList.add('is-tip');
          rewardStep.setAttribute('aria-expanded', 'true');
        }
        return;
      }

      var prev = e.target.closest('[data-fav-prev]');
      if (prev) {
        if (!prev.disabled) scrollFavorites(-1);
        return;
      }

      var next = e.target.closest('[data-fav-next]');
      if (next) {
        if (!next.disabled) scrollFavorites(1);
        return;
      }

      var add = e.target.closest('[data-fav-add]');
      if (add) {
        addFavorite(add);
        return;
      }

      var step = e.target.closest('[data-qty-change]');
      if (step) {
        if (step.disabled) return;
        var input = step.closest('[data-line-key]').querySelector('[data-focus="qty"]');
        var delta = Number(step.getAttribute('data-qty-change'));
        var base = parseInt(input.value, 10) || 0;
        var next = clamp(input, base + delta);
        if (delta < 0) next = Math.max(1, next);
        if (next === base) return;
        input.value = next;
        schedule(lineKeyOf(step), next);
        return;
      }

      var remove = e.target.closest('[data-cart-remove]');
      if (remove) schedule(lineKeyOf(remove), 0);
    });

    dialog.addEventListener('change', function (e) {
      if (e.target.matches('[data-fav-select]')) {
        syncFavoriteOption(e.target);
        return;
      }
      if (e.target.matches('[data-focus="qty"]')) commitInput(e.target);
    });

    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && dialog.querySelector('[data-mk-reward-step].is-tip')) {
        e.preventDefault();
        e.stopPropagation();
        closeRewardTips(dialog);
        return;
      }
      if (e.key !== 'Enter' || !e.target.matches('[data-focus="qty"]')) return;
      e.preventDefault();
      commitInput(e.target);
    });

    dialog.addEventListener('submit', function (e) {
      if (!pending) return;
      e.preventDefault();
      idle().then(submitCheckout);
    });

    bindFavorites(dialog);
  }

  function openAfterAdd(trigger) {
    if (!getDialog()) return false;
    refresh().catch(noop).then(function () {
      open(trigger);
    });
    return true;
  }

  function closeRewardTips(root) {
    var scope = root || document;
    var openTips = scope.querySelectorAll('[data-mk-reward-step].is-tip');
    for (var i = 0; i < openTips.length; i++) {
      openTips[i].classList.remove('is-tip');
      openTips[i].setAttribute('aria-expanded', 'false');
    }
  }

  var skippedRewards = {};
  var removingReward = {};

  function parseSkip(value) {
    var ids = [];
    String(value || '').split(',').forEach(function (part) {
      var id = part.trim();
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    ids.sort();
    return ids;
  }

  function rememberSkip(id) {
    if (id) skippedRewards[id] = true;
  }

  function forgetSkip(id) {
    delete skippedRewards[id];
  }

  function skipKey() {
    return Object.keys(skippedRewards).sort().join(',');
  }

  function hydrateSkips(cart) {
    parseSkip(cart && cart.attributes && cart.attributes._mk_skip_rewards).forEach(rememberSkip);
  }

  function persistSkips() {
    return fetch(cartEndpoint('cart_url', 'cart.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(readJson).then(function (cart) {
      hydrateSkips(cart);
      var next = skipKey();
      var current = parseSkip(cart.attributes && cart.attributes._mk_skip_rewards).join(',');
      if (next === current) return cart;
      return fetch(cartEndpoint('cart_update_url', 'cart/update.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { _mk_skip_rewards: next } })
      }).then(readJson);
    });
  }

  function declineReward(id) {
    rememberSkip(id);
    var run = rewardChain.then(persistSkips, persistSkips).then(function () {
      return null;
    }, function () {
      return null;
    });
    rewardChain = run;
    return run;
  }

  function rewardIdOf(item) {
    var props = item && item.properties;
    if (!props) return '';
    if (Object.prototype.toString.call(props) === '[object Array]') {
      for (var i = 0; i < props.length; i++) {
        var prop = props[i];
        if (!prop) continue;
        if (prop.name === '_mk_reward' || prop.first === '_mk_reward') return prop.value || prop.last || '';
      }
      return '';
    }
    return props._mk_reward || '';
  }

  function rewardConfig() {
    var node = document.getElementById('MkCartRewards');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (err) {
      return null;
    }
  }

  var rewardChain = Promise.resolve();
  var rewardQueued = 0;
  var rewardBatchChanged = false;

  function syncRewards() {
    rewardQueued += 1;
    var run = rewardChain.then(syncRewardsOnce).then(function (changed) {
      if (changed) rewardBatchChanged = true;
      return finishRewardBatch();
    }, function () {
      return finishRewardBatch();
    });
    rewardChain = run.then(function () { return null; }, function () { return null; });
    return run;
  }

  function finishRewardBatch() {
    rewardQueued -= 1;
    if (rewardQueued > 0) return false;
    var changed = rewardBatchChanged;
    rewardBatchChanged = false;
    if (!changed) return false;
    if (onCartPage()) {
      window.location.reload();
      return true;
    }
    if (document.getElementById('CartDrawer')) return refresh().then(function () { return true; });
    return true;
  }

  function syncRewardsOnce() {
    var config = rewardConfig();
    if (!config) return Promise.resolve(false);
    return fetch(cartEndpoint('cart_url', 'cart.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(readJson).then(function (cart) {
      var worth = 0;
      var items = cart.items || [];
      items.forEach(function (item) {
        if (!rewardIdOf(item)) worth += item.final_line_price || 0;
      });
      var storedSkip = parseSkip(cart.attributes && cart.attributes._mk_skip_rewards).join(',');
      hydrateSkips(cart);
      var adds = [];
      var updates = {};
      var changed = false;
      (config.gifts || []).forEach(function (gift) {
        if (!gift || !gift.variant || !gift.cents) return;
        var line = null;
        items.forEach(function (item) {
          if (rewardIdOf(item) === gift.id) line = item;
        });
        var skipped = skippedRewards[gift.id] === true;
        if (worth >= gift.cents) {
          if (skipped) {
            if (line && !removingReward[gift.id]) {
              updates[line.key] = 0;
              changed = true;
            }
            return;
          }
          if (!line) {
            adds.push({
              id: gift.variant,
              quantity: 1,
              properties: { _mk_reward: gift.id }
            });
            changed = true;
          } else if (line.quantity !== 1) {
            updates[line.key] = 1;
            changed = true;
          }
        } else {
          if (skipped) forgetSkip(gift.id);
          if (line) {
            updates[line.key] = 0;
            changed = true;
          }
        }
      });
      var attributes = null;
      if (skipKey() !== storedSkip) {
        attributes = { _mk_skip_rewards: skipKey() };
        changed = true;
      }
      if (!changed) return null;
      var chain = Promise.resolve();
      var updateKeys = Object.keys(updates);
      if (updateKeys.length || attributes) {
        var payload = {};
        if (updateKeys.length) payload.updates = updates;
        if (attributes) payload.attributes = attributes;
        chain = chain.then(function () {
          return fetch(cartEndpoint('cart_update_url', 'cart/update.js'), {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload)
          }).then(readJson);
        });
      }
      adds.forEach(function (item) {
        chain = chain.then(function () {
          var rewardId = item.properties && item.properties._mk_reward;
          if (rewardId && skippedRewards[rewardId]) return null;
          return fetch(cartEndpoint('cart_add_url', 'cart/add.js'), {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [item] })
          }).then(readJson);
        });
      });
      return chain.then(function () { return true; });
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-mk-reward-step]')) closeRewardTips(document);
  });

  document.addEventListener('click', function (e) {
    if (onCartPage()) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (typeof e.button === 'number' && e.button !== 0) return;
    var link = cartTriggerFrom(e.target);
    if (!link || !getDialog()) return;
    e.preventDefault();
    e.stopPropagation();
    if (stale) {
      refresh().catch(noop).then(function () {
        open(link);
      });
      return;
    }
    open(link);
    refresh().catch(noop);
  }, true);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    if (!root || !root.querySelector) return;
    var dialog = root.querySelector('#CartDrawer');
    if (!dialog) return;
    dialog._mkBound = false;
    getDialog();
  });

  document.addEventListener('cart:updated', function () {
    stale = true;
    syncRewards().then(function (synced) {
      var dialog = getDialog();
      if (synced || pending || !dialog || !dialog.open) return;
      return refresh();
    }).catch(noop);
  });

  if (typeof window.jQuery === 'function') {
    jQuery(document).ajaxComplete(function (event, xhr, settings) {
      if (!settings || !/\/cart\/(add|change|update|clear)/.test(settings.url || '')) return;
      if (typeof settings.data === 'string' && settings.data.indexOf('"sections":"' + SECTION_ID + '"') !== -1) return;
      stale = true;
      syncRewards();
    });
  }

  syncRewards();

  window.addEventListener('pageshow', function (e) {
    var dialog = e.persisted && getDialog();
    if (dialog && dialog.open) refresh().catch(noop);
  });

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', syncViewport);
    window.visualViewport.addEventListener('scroll', syncViewport);
  }

  window.addEventListener('resize', function () {
    syncFavorites(document.getElementById('CartDrawer'));
  });

  window.theme = window.theme || {};
  theme.cartDrawer = {
    open: open,
    close: close,
    refresh: refresh,
    openAfterAdd: openAfterAdd
  };
})();
